<template>
    <div class="vm-tip-toast" v-show="config.is_show">
        <div class="inner-box flex-box flex-justify-content-space-between">
            <div class="flex-item-1">
                <div class="tit fs12 fwb mb4">{{config.title}}</div>
                <div class="text">
                    {{config.content}}
                    <template v-if="config.url_name && config.url">
                        <router-link v-if="is_afd_url" class="url-name ml16" :to="config.url.replace(/^https:\/\/afdian\.net/,'')">{{config.url_name}}</router-link>
                        <a v-else class="url-name ml16" target="_blank" :href="config.url">{{config.url_name}}</a>
                    </template>
                </div>
            </div>
            <i class="afd afd-x p16" @click="close"></i>
        </div>
    </div>
</template>

<script>

export default {
    name: 'tip-toast',
    props: {
        config: {
            type: Object,
            default(){
                return {}
            }
        },
    },
    data() {
        return {
        };
    },
    computed:{
        is_afd_url(){
            return this.config.url && this.config.url.includes('afdian.net')
        }
    },
    mounted() {
    },
    beforeDestroy() {
    },
    methods: {
        close(){
            this.$emit('close', this.config)
        }
    }
};
</script>

<style lang="stylus" scoped>
.vm-tip-toast{
    background $purple
    padding px2rem(16)
    position fixed
    top px2rem(80)
    left 0
    width 100%
    z-index 99
    .inner-box{
        position relative
        max-width $width-pc
        margin 0 auto
    }
    .tit{
        color $white
    }
    .text{
        color $white
        max-width 85%
    }
    .afd-x{
        color $white-5
        cursor pointer
        position absolute
        right 0
        top 50%
        transform translateY(-50%)
        &:hover{
            color $white
        }
    }
    .url-name{
        color $yellow
        text-decoration underline
    }
    @media (max-width: $width-mobile) {
        top px2rem(64)
        padding px2rem(16) 0
        .inner-box {
            padding 0 px2rem(16)
            margin 0
        }
    }
}

</style>
